var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.19 13.6367H19.81C16.17 13.6367 14 15.8067 14 19.4467V27.8167C14 31.4667 16.17 33.6367 19.81 33.6367H28.18C31.82 33.6367 33.99 31.4667 33.99 27.8267V19.4467C34 15.8067 31.83 13.6367 28.19 13.6367ZM24 27.5167C21.86 27.5167 20.12 25.7767 20.12 23.6367C20.12 21.4967 21.86 19.7567 24 19.7567C26.14 19.7567 27.88 21.4967 27.88 23.6367C27.88 25.7767 26.14 27.5167 24 27.5167ZM29.92 18.5167C29.87 18.6367 29.8 18.7467 29.71 18.8467C29.61 18.9367 29.5 19.0067 29.38 19.0567C29.26 19.1067 29.13 19.1367 29 19.1367C28.73 19.1367 28.48 19.0367 28.29 18.8467C28.2 18.7467 28.13 18.6367 28.08 18.5167C28.03 18.3967 28 18.2667 28 18.1367C28 18.0067 28.03 17.8767 28.08 17.7567C28.13 17.6267 28.2 17.5267 28.29 17.4267C28.52 17.1967 28.87 17.0867 29.19 17.1567C29.26 17.1667 29.32 17.1867 29.38 17.2167C29.44 17.2367 29.5 17.2667 29.56 17.3067C29.61 17.3367 29.66 17.3867 29.71 17.4267C29.8 17.5267 29.87 17.6267 29.92 17.7567C29.97 17.8767 30 18.0067 30 18.1367C30 18.2667 29.97 18.3967 29.92 18.5167Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.5,
    stroke: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIg);
export default __webpack_public_path__ + "static/media/ig.faa06a8d239bfaa82cc6602491b15858.svg";
export { ForwardRef as ReactComponent };